import React from "react";
import ReactDom from "react-dom";
import "../css/PreviewModal.css";

const PreviewModal = ({ open, close, children }) => {
  if (!open) return null;

  if (open === true) {
    return ReactDom.createPortal(
      <>
        <div className="overlay" onClick={close} />
        <div className="PreviewModal">{children}</div>
      </>,
      document.getElementById("portal")
    );
  }
};

export default PreviewModal;
